import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';

import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { actionCreators } from '../../store/LoginActionsReducers';
import api from '../../ApiService';
import UserEditor from '../Admin/UserEditor';
import { UserRoles } from '../../helper';
import './Users.css';

class Users extends React.Component {
    constructor(props) {
        super(props);

        this.switchToEditMode = this.switchToEditMode.bind(this);

        this.state = {
            isEditing: false,
            showInactive: false,
            allUsers: [],
            users: []
        };
    }

    componentDidMount = async () => {
        await this.refreshUsersTable(false);
    }

    switchToEditMode = (rowData) => {
        let userId = null;
        if (rowData !== null) {
            // Disallow edit of super user.
            if (rowData.data.role === UserRoles.SuperUser && this.props.userRole !== UserRoles.SuperUser) {
                toast.error("You do not have permission to edit Super Users.");
                return;
            }

            userId = rowData.data.id;
        }

        this.setState({ isEditing: true, editUserId: userId });
    }

    cancelEditMode = (e) => {
        this.setState({ isEditing: false });
    }

    refreshUsersTable = async (isEditing) => {
        let allUsers = await api.getUsers();
        this.setState({ isEditing: isEditing, allUsers: allUsers }, () => this.updateFilteredUsers(this.state.showInactive));
    }

    updateFilteredUsers = (showInactive) => {
        let filteredUsers = this.state.allUsers.filter(user => showInactive || user.isActive);
        this.setState({ users: filteredUsers, showInactive: showInactive });
    }

    formatLastLoginDate = (rowData) => {
        if (rowData.lastLogin) {
            let lastLogin = new Date(rowData.lastLogin);
            return <span>{lastLogin.toLocaleString()}</span>
        }
    }

    renderUsersTable = () => {
        return (
            <div>
                { /* Title */ }
                <Grid container justify="space-between" style={{ paddingBottom: '10px' }}>
                    <Grid item>
                        <h3>Users</h3>
                    </Grid>
                    <Grid item style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                        <FormControlLabel control={
                                <Switch
                                    checked={this.state.showInactive}
                                    onChange={(e) => this.updateFilteredUsers(e.target.checked)}
                                    color="secondary"
                                />
                            }
                            label="Show inactive"
                        />
                        <Button variant='contained' color='primary' onClick={() => this.switchToEditMode(null)} disabled={this.props.isEditing}>Create User</Button>
                    </Grid>
                </Grid>

                { /* Table */}
                <div style={{ paddingBottom: '10px' }}>
                    <DataTable value={this.state.users} onRowClick={this.switchToEditMode}>
                        <Column field="email" header="Email" sortable />
                        <Column field="fullName" header="Full Name" sortable />
                        <Column field="hospitalOrAffiliateName" header="Hospital / Affiliate / GPO" sortable />
                        <Column field="role" header="Role" sortable />
                        <Column field="lastLogin" header="Last Login" body={this.formatLastLoginDate} sortable />
                        <Column field="isActive" header="Active"
                            body={(rowData) => <span>{(rowData.isActive ? "Yes" : "No")}</span>}
                            style={(this.state.showInactive ? undefined : { display: "none" })}
                        />
                        { /* <Column body={this.actionTemplate} header={this.addButton()} style={{ textAlign: 'center', width: '6em' }} /> */}
                    </DataTable>
                </div>
                <br />
                <br />
            </div>
        );
    }

    render() {
        if (this.state.isEditing) {
            return (
                <UserEditor
                    userId={this.state.editUserId}
                    onCancel={this.cancelEditMode}
                    onSaveSuccess={this.refreshUsersTable}
                />
            );
        }
        else {
            return this.renderUsersTable();
        }
    }
}

export default withRouter(connect(state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Users));


// WEBPACK FOOTER //
// ./src/components/Admin/Users.js